
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spotlight/[...slug]",
      function () {
        return require("private-next-pages/spotlight/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spotlight/[...slug]"])
      });
    }
  